import { create } from "zustand";
import { createJSONStorage, persist } from 'zustand/middleware';

import type { Role } from "./useUserRole";

interface CustomRolesStore {
    customRoles: Role[] | null;
}

export const useCustomRolesStore = create(
    persist<CustomRolesStore>(
        () => {
            return {
                customRoles: null,
            };
    }, {
        name: 'custom-roles',
        storage: createJSONStorage(() => sessionStorage),
    })
);

export const setCustomRoles = (roles: Role[]) => {
    useCustomRolesStore.setState({ customRoles: roles });
};

export const clearCustomRoles = () => {
    useCustomRolesStore.setState({ customRoles: null });
};

export const getCustomRoles = () => {
    return useCustomRolesStore.getState().customRoles;
};